import { HTMLAttributes } from 'react'

import { useChangePathname } from '@/hooks'

export type LayoutProps = HTMLAttributes<HTMLElement>

const Layout = ({ children }: LayoutProps) => {
  useChangePathname()

  return <>{children}</>
}

export default Layout
